import { render } from "./CGridIconColumn.vue?vue&type=template&id=05f1fe60&scoped=true"
import script from "./CGridIconColumn.vue?vue&type=script&lang=js"
export * from "./CGridIconColumn.vue?vue&type=script&lang=js"

import "./CGridIconColumn.vue?vue&type=style&index=0&id=05f1fe60&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f1fe60"]])

export default __exports__